import { Language } from './language';

const zh = {
    code: Language.zh,

	// HOME PAGE
	
	t_description: '女鼓手，{age}岁',
	t_close: '关闭',
	
	b_home: '首页',
	b_about: '关于我',
	b_press: '新闻与媒体',
	b_shows: '现场表演',
	b_latest_show: '最新',
	b_soultone: '灵魂音',
	b_paiste: 'Paiste',
	b_collision: '碰撞',
	b_language: '中国人',
	b_share: '分享',
	b_scroll_to_top: '滚动至顶部',
	b_click: '拍答',
	b_tap: '点击',

	t_english: '英语',
	t_spanish: '西班牙语',
	t_portuguese: '葡萄牙语',
	t_italian: '意大利语',
	t_french: '法语',
	t_german: '德语',
	t_chinese: '中国人',

	// SHOWS PAGE

	KRKComeTogether2026DROM_title: 'KRFK Come Together 音乐节',
	KRKComeTogether2026DROM_description: 'DROM，纽约市',

	KRKComeTogether2026Chelsea_title: 'KRFK Come Together 音乐节',
	KRKComeTogether2026Chelsea_description: 'Chelsea Table & Stage，纽约市',

	RockFantasy2026Whisky_title: '摇滚幻想营',
	RockFantasy2026Whisky_description: 'The Whisky a Go Go，Hollywood CA。',

	RockFantasy2026Viper_title: '摇滚幻想营',
	RockFantasy2026Viper_description: 'The Viper Room，Hollywood CA。',

	FulcrumCelebrationOfLight2026_title: 'Fulcrum 光之庆典',
	FulcrumCelebrationOfLight2026_description: '西雅图喜来登大酒店',

	QueenTribute_title: 'Queen 致敬演出',
	QueenTribute_description: '西雅图摇滚学校',

	FremontFridays2025_title: '弗里蒙特星期五 二零二五',
	FremontFridays2025_description: '西雅图的弗里蒙特星期五',

	DrumFantasyCamp2025_title: '鼓幻想训练营 2025',
	DrumFantasyCamp2025_description: '洛杉矶鼓幻想训练营',

	ClassicMetal_title: '经典金属',
	ClassicMetal_description: '西雅图摇滚学校',

	StAlsGrandDay2024_title: '2024 年盛大日演出',
	StAlsGrandDay2024_description: '圣阿方索斯教区学校 西雅图',

	BlackViolinConcert_title: '与世界你的乐团的黑色小提琴音乐会',
	BlackViolinConcert_description: '派拉蒙剧院',

	MexicanIndependenceDay2024_title: '巴拉德市民管弦乐团庆祝墨西哥独立日',
	MexicanIndependenceDay2024_description: '西雅图市政厅',

	BluesRock_title: '蓝调摇滚',
	BluesRock_description: '西雅图摇滚学校',

	BallardSeaFoodFest2024_title: '二零二四 巴拉德海鲜节',
	BallardSeaFoodFest2024_description: '巴拉德海鲜节',

	Funk_title: '放克',
	Funk_description: '西雅图摇滚学校',

	Heart_title: '心',
	Heart_description: '西雅图摇滚学校',

	ModernMetal_title: '现代金属',
	ModernMetal_description: '西雅图摇滚学校',

	SeasonPreviewWinter2023_title: '二零二三 年冬季季节预览',
	SeasonPreviewWinter2023_description: '西雅图摇滚学校',

	SmashingPumpkins_title: '粉碎南瓜',
	SmashingPumpkins_description: '西雅图摇滚学校',

	Nirvana_title: '涅槃',
	Nirvana_description: '西雅图摇滚学校',

	HairMetal_title: '头发金属',
	HairMetal_description: '西雅图摇滚学校',

	TalentShow2023_title: '二零二三才艺展示',
	TalentShow2023_description: '西雅图鲑鱼湾小学',

	Deftones_title: '去色调',
	Deftones_description: '西雅图摇滚学校',

	SeasonPreviewSpring2023_title: '二零二三 年春季季前瞻',
	SeasonPreviewSpring2023_description: '西雅图摇滚学校',

	Ramones_title: '雷蒙斯',
	Ramones_description: '西雅图摇滚学校',

	Soundtrack_title: '配乐秀',
	Soundtrack_description: '西雅图摇滚学校',

	PopPunkVsEmo_title: '流行朋克与。 情绪',
	PopPunkVsEmo_description: '西雅图摇滚学校',

	_90sNostalgia_title: '九零年代怀旧',
	_90sNostalgia_description: '西雅图摇滚学校',

	TalentShow2022_title: '二零二二才艺展示',
	TalentShow2022_description: '西雅图鲑鱼湾小学',

	// PRESS PAGE

	fox_13_news_title: '狐狸十三西雅图新闻专题报道',
	fox_13_news_description: '真正的西北部分特色',

	b_watch_here: '在这里观看',

	king_5_feature_title: 'Fulcrum / King 5 专题报道',
	king_5_feature_description: '由 Fulcrum 赞助的西雅图 King 5 电视专题报道',

	bateristland_title: 'Bateristland Featuring',
	bateristland_description: 'Bateristland YouTube 频道采访',

	komo_news_title: 'KOMO新闻报道',
	komo_news_description: '西雅图精致访谈',

	andrew_rooney_drums_title: 'Andrew Rooney 反应',
	andrew_rooney_drums_description: 'Andrew Rooney 对 Victoria 演奏的 Rush《Tom Sawyer》做出反应',

	upper_lefters_interview_title: 'Upper Lefters 采访',
	upper_lefters_interview_description: 'Upper Lefters YouTube 频道关于 Victoria 职业生涯和未来计划的采访',

	the_eagle_969_title: '96.9 The Eagle 经典金曲电台',
	the_eagle_969_description: '96.9 The Eagle Classic Hits 关于 Victoria 的 Rush 翻奏博客文章',

	the_daly_migs_show_interview_title: '达利米奇秀采访',
	the_daly_migs_show_interview_description: '关于受邀加入 Godsmack 舞台的采访',

	alizee_defan_07_02_2024_title: '《艾莉婕·德凡》专访',
	alizee_defan_07_02_2024_description: '独家专访',

	jaime_mendez_news_06_26_2024_title: '《海梅·门德斯新闻》采访',
	jaime_mendez_news_06_26_2024_description: '西雅图当地西班牙语新闻',

	bien_informado_03_22_2023_title: '“消息灵通" 文章',
	bien_informado_03_22_2023_description: '阿根廷新闻网站关于维多利亚鼓的文章',

	wave_potter_reaction_01_30_2023_title: '波波特 反应',
	wave_potter_reaction_01_30_2023_description: '波波特 对 胜利 的 永恒之光 封面做出反应',

	// ABOUT PAGE

	b_back: '回去',

	t_title: 'Victoria Acosta',
	t_pronouns: '她',

	b_read_more: '阅读更多',
	b_read_less: '阅读较少',
	b_stat_age: '年龄',
	b_stat_shows: '现场演出',
	b_stat_yrs: '打鼓年限',
	b_stat_awards: '奖项',

	t_about: `
手握鼓棒、心怀节奏，{age}岁的维多利亚·阿科斯塔（Victoria Acosta）是当今最受期待的年轻鼓手之一。她出生于德克萨斯州埃尔帕索（El Paso），在墨西哥瓜达拉哈拉（Guadalajara）长大，如今定居西雅图（Seattle），以她的专注、能量和舞台表现力著称。

维多利亚四岁开始打鼓，并于二零一八年九月十三日收到第一套鼓。她在瓜达拉哈拉的Musicalerias Academy接受训练，后来在西雅图继续学习。二零二二年五月二十九日参加School of Rock试课后，她跳过Rock 101，直接进入Performers Program。此后，她已参加{shows}场现场演出。

她为社交媒体录制了数百个视频。二零二四年六月十三日，她受意大利作曲家Alberto Rigonni邀请，作为嘉宾鼓手参与Nemesis Call。同年九月十二日，她获得Soultone Cymbals代言，并于二零二五年三月八日加入Collision Drumsticks艺术家团队。

二零二五年八月，维多利亚参加洛杉矶的Drum Fantasy Camp，向Dave Weckl、Dennis Chambers、Peter Erskine和Gavin Harrison学习。同月，她还开始跟随鼓乐教育家Dave Stark学习，他的指导持续提升着她的技术、音乐性和艺术表达。

二零二六年二月十三日，维多利亚正式成为Paiste艺术家。同月，她参加Rock and Roll Fantasy Camp，与Nita Strauss、Stewart Copeland、Monte Pittman、Steve Stevens、Skunk Baxter和Leland Sklar合作，并在Viper Room和Whisky a Go Go演出。二零二六年，她还赢得了Neil Peart Drum Set奖学金，该奖学金由Percussive Arts Society和Hudson颁发。

除了打鼓，维多利亚在四年级开始学习小提琴，并于二零二四年加入World Youth Orchestra。她曾与Black Violin在Paramount Theatre同台，并在Town Hall Seattle随Ballard Civic Orchestra首次作为打击乐手演出，庆祝墨西哥独立日。

她的荣誉包括二零二二年London Young Musician Contest的Gold Prize和Fantastic Technique Award，以及二零二三年的Annual Star Musician Award和Outstanding Drummer Special Award。维多利亚每天练习，以坚定和创造力不断突破极限。
`,

	// PRESS PAGE

	t_footer: '版权所有',

	// SOULTONE: 

	b_visit_artist_page: '访问我的艺术家页面',

}

export default zh;
